<template>
  <div>
    <div id="Chart21" style="width: 100%; height: 180px"></div>
    <div class="chart21_table">
      <table border="1" cellspacing="0">
        <tr>
          <th v-for="(item, index) in table_data" :key="'1' + index">
            {{ item.data1 }}
          </th>
        </tr>
        <tr>
          <td v-for="(item, index) in table_data" :key="'2' + index">
            {{ item.data2 }}
          </td>
        </tr>
        <tr class="tr3">
          <td v-for="(item, index) in table_data" :key="'3' + index">
            {{ item.data3 }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_data: [
        {
          data1: "2010",
          data2: "60亿",
          data3: "60亿",
        },
        {
          data1: "2010",
          data2: "60亿",
          data3: "60亿",
        },
        {
          data1: "2010",
          data2: "60亿",
          data3: "60亿",
        },
        {
          data1: "2010",
          data2: "60亿",
          data3: "60亿",
        },
        {
          data1: "2010",
          data2: "60亿",
          data3: "60亿",
        },
      ],
    };
  },
  methods: {
    myEcharts21() {
      var myChart21 = this.$echarts.init(document.getElementById("Chart21"));
      //配置图表
      var option21 = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: -40,
          right: -40,
          bottom: 0,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },

          data: ["2016", "2017", "2018", "2019", "2020"],
          axisLabel: {
            formatter: function () {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return ``;
            },
          },
        },
        yAxis: [
          {
            type: "value",
            show: false,
            position: "left",
          },
          {
            type: "value",
            show: false,
            position: "right",
            axisLabel: {
              formatter: function (value) {
                return value + "%";
              },
            },
          },
        ],
        series: [
          {
            name: "归母净利润",
            type: "bar",
            data: [123, 456, 789, 965, 324],
            color: "#fcad2a",
            barWidth: 16,
            barGap: "50%",
          },
          {
            name: "同比增长率",
            type: "line",
            data: [14.12, 12.36, 15.63, 18.61, 12.58],
            color: "#579eff",
            barWidth: 16,
            barGap: "50%",
            yAxisIndex: 1,
            symbol: "circle",
            label: {
              formatter: "{c}%",
              color: "#579eff",
              show: true,
              position: "top",
            },
          },
        ],
      };
      myChart21.setOption(option21);
    },
  },
  mounted() {
    this.myEcharts21();
  },
};
</script>

<style scoped>
.chart4_table {
  margin-top: 50px;
}
table {
  border-color: #e9ebf3;
  border-collapse: collapse;
}
th,
td {
  width: 288px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}
th {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
td {
  font-size: 14px;
  color: #fcad2a;
}
.tr3 td {
  color: #579eff;
}
.chart21_table{
  margin-top: 30px;
}
</style>